import React, { useState, useRef, useEffect } from "react";
import about from "../../assets/image/about_nha_pg_logo.png";
import { MobileOTPServices, mobileOtpVerifyServices } from "../../services";
import { useSelector } from "react-redux";

const MobileOtp = ({ setMobileOtp, setIsVerifiedOtp, mobileNumber }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpGuid, setOtpGuid] = useState("");
  const [displayMobileNumber, setDisplayMobileNumber] = useState("");
  const [timer, setTimer] = useState(0);

  // const sendMobileNumber = useSelector((state) => state.user.mobileNumber);
  const uuid = useSelector((state) => state.user.UUid);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (mobileNumber) {
      setDisplayMobileNumber(mobileNumber);
    }
    const savedResponse = localStorage.getItem("otpResponse");
    if (savedResponse) {
      try {
        const response = JSON.parse(savedResponse);
        const guid = response?.data?.data?.otpGuid;
        if (guid) {
          setOtpGuid(guid);
        } else {
          setError("No valid OTP session found. Please resend OTP.");
        }
      } catch (error) {
        setError("Failed to load OTP session. Please resend OTP.");
      }
    } else {
      setError("No OTP session found. Please resend OTP.");
    }
  }, [mobileNumber]);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const sendMobileNumber = localStorage.getItem("mobile");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const verificationResponse = await VerifymobileOtp(otpValue);

      const statusCode = verificationResponse?.data?.data?.statusCode;
      const statusMessage = verificationResponse?.data?.data?.statusMessage;

      if (verificationResponse?.success && statusCode === "0") {
        const patientDetails = verificationResponse.data?.data?._PatientDetails;

        if (patientDetails && Array.isArray(patientDetails)) {
          localStorage.setItem(
            "patientDetails",
            JSON.stringify(patientDetails)
          );
        } else {
          localStorage.setItem("patientDetails", JSON.stringify([]));
        }
        setIsVerifiedOtp(true);
        setMobileOtp(false);
        localStorage.removeItem("otpResponse");
        setError(null);
      } else {
        // OTP is invalid or other error
        setError(statusMessage || "OTP verification failed");
        setIsVerifiedOtp(false);
        setMobileOtp(true);
      }
    } catch (error) {
      setError("Verification failed. Please enter correct otp.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        // Changed to 5 for 6-digit OTP
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const VerifymobileOtp = async (otpValue) => {
    try {
      const body = {
        guid: uuid,
        otp: otpValue,
      };
      return await mobileOtpVerifyServices({ body });
    } catch (error) {
      console.error("Error while verifying OTP:", error);
      throw error;
    }
  };

  const sendOtp = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const body = {
        mobile: sendMobileNumber,
      };

      const response = await MobileOTPServices({ body });
      console.log("OTP Send Response:", response);

      if (response?.success && response.data?.statusCode === "0") {
        const otpData = response.data.data;
        if (otpData?.otpGuid) {
          setOtpGuid(otpData.otpGuid);
          localStorage.setItem("otpResponse", JSON.stringify(response));
          setOtp(["", "", "", "", "", ""]);
          setError("OTP sent successfully!");
          setTimeout(() => {
            setError(null);
          }, 5000);
        } else {
          setError("OTP sent but technical error occurred");
          localStorage.removeItem("otpResponse");
        }
      } else {
        const errorMessage =
          response.data?.statusMessage || "Failed to send OTP";
        setError(errorMessage);
        if (response.data?.statusCode === "1") {
          setOtpGuid("");
          localStorage.removeItem("otpResponse");
        }
      }
      setTimer(60);
    } catch (error) {
      console.error("Send OTP error:", error);
      setError("Failed to send OTP. Please try again.");
      localStorage.removeItem("otpResponse");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Create / Link Your ABHA</h3>
                <p className="pt-4">
                  Enter OTP Received on Your Number +91 {sendMobileNumber}
                </p>
                {error && (
                  <div
                    className={`alert ${
                      error.includes("successfully")
                        ? "alert-success"
                        : "alert-danger"
                    }`}
                  >
                    {error}
                  </div>
                )}
                <form onSubmit={handleSubmit} className="pt-4">
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                    <div className="row">
                      {otp.map((digit, index) => (
                        <div
                          key={index}
                          className="col-ms-2 col-lg-2 col-xl-2 col-sm-2 col-xs-2"
                        >
                          <input
                            type="text"
                            maxLength="1"
                            placeholder="0"
                            value={digit}
                            ref={(el) => (inputRefs.current[index] = el)}
                            onChange={(e) => handleInputChange(e, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className="mobile-input otp"
                            disabled={isLoading}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <button
                    type="submit"
                    className={`continue-btn ${
                      isLoading || otp.join("").length !== 6 ? "bg-disable" : ""
                    }`}
                    disabled={isLoading || otp.join("").length !== 6}
                  >
                    {isLoading ? "Verifying..." : "Continue"}
                  </button>

                  <p className="pt-2">
                    Don't Receive ОТР To Your Number ?{" "}
                    {timer > 0 ? (
                      <span className="text-success">Resend in {timer}s</span>
                    ) : (
                      <button
                        type="button"
                        className="resend-otp btn-link"
                        onClick={sendOtp}
                        disabled={isLoading}
                      >
                        Resend OTP
                      </button>
                    )}
                  </p>
                </form>
                <div className="nha-logo-container">
                  <span>APPROVED BY NHA</span>
                  <img src={about} alt="NHA Logo" className="nha-logo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MobileOtp;
